module.exports = __webpack_public_path__ + "static/media/tanzania.da39b6c1.jpg";